<template>
    <v-card >
      <v-container v-if="sumfurush_card">
        <v-card-title class="pa-0 mb-2">Отчёт оплата поставщикам
          <v-divider class="mx-2" inset vertical></v-divider>
          <export-excel
          :data="filteredProducts"
          :worksheet="'Отчёт о оплата поставщики  '  "
          :name="'Отчёт о оплата поставщики - ' + date1  + ' - ' + date2  "
          :title="'Отчёт о оплата поставщики ' + date1  + ' - ' + date2  "
          :fields="oplata_firma_fields"
          :auto-width="true"
          >
          <v-icon  color="success" >
              mdi-microsoft-excel
              </v-icon>
      </export-excel>




        </v-card-title>
        <v-row class="mb-2">
          <v-col cols="12" md="3">
              <v-menu class="m-2"
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              :return-value.sync="date1"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="date1"
                  label="Дата 1"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  solo
                  hide-details
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="date1"
                no-title
                scrollable
              >
                <v-spacer></v-spacer>
                <v-btn
                  text
                  color="primary"
                  @click="menu = false"
                >
                  Отмена
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="get_vozvratho"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>




            <v-autocomplete
            clearable
            item-color="primary"
            color="primary"
            hide-no-data
            label="Поставщики"
            hide-details
            multiple
            solo
            prepend-icon="mdi-filter-menu-outline"
            :items="firmaho"
            item-text="nom"
            item-value="nom"
            class="m-4"
            @click:clear="get_vozvratho"
            v-model="filters.firma" />


          </v-col>

          <v-col cols="12" md="3">

              <v-menu
              ref="menu2"
              v-model="menu2"
              :close-on-content-click="false"
              :return-value.sync="date2"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="date2"
                  label="Дата 2"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  solo
                  hide-details
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="date2"
                no-title
                scrollable
              >
                <v-spacer></v-spacer>
                <v-btn
                  text
                  color="primary"
                  @click="menu2 = false"
                >
                  Отмена
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="get_vozvratho"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>



            <v-autocomplete class="m-4"
            clearable
             item-color="primary"
             color="primary"
             hide-no-data
             hide-details
             multiple
             solo
             prepend-icon="mdi-filter-menu-outline"
             :items="valutaho"
             item-text="valuta"
             item-value="valuta"
             label="Валюта"
             @click:clear="get_vozvratho"
             v-model="filters.valuta" />
          </v-col>
          <v-col cols="12" md="4">

              <v-text-field
              color="primary"
              prepend-inner-icon="mdi-magnify"
              solo
              v-model="filters.comment"
              label="Поиск комментарии"/>

          </v-col>

        </v-row>

        <v-data-table dense
        :headers="headers"
        :items="filteredProducts"
        item-key="id_pardokht"
        class="elevation-1"
        :search="filters.comment"
        :loading="loading"
                  loading-text="Загрузка. Пожалуйста подождите"
                    :footer-props="{
                        'items-per-page-options': [ 7, 20, 50, 100],
                        'items-per-page-text':'Строк на странице',
                    }"
                    no-data-text="Данные отсутствуют в таблице"
                    >




          <template slot="body.append">
              <tr>
                  <th class="title "></th>
                  <th class="title ">Итого</th>
                  <th class="title ">{{Number( sumField('mablag')).toFixed(2) }}</th>
                  <th class="title ">{{Number( sumField('mablagi_kurs')).toFixed(2) }}</th>
                  <th class="title "></th>
                  <th class="title "></th>
                  <th class="title "></th>
              </tr>
          </template>

        </v-data-table>
      </v-container>

      <!-- <v-container v-if="furush_card">

          <v-card-title>
              <v-icon @click="back_to_sumfurush" color="primary">
                  mdi-arrow-left
              </v-icon>
              <v-divider class="mx-4" inset vertical></v-divider>
              <h3 class="headline mb-0">Возврат № {{vozvrat.id_sum_vozvrat}}</h3>
              <v-divider class="mx-4" inset vertical></v-divider>

              <export-json-excel
              :data="vozvrat_list"
              :fields="export_furush_fields"
              :worksheet="'Возврат № '+vozvrat.id_sum_vozvrat"
              :name="'Возврат №' + vozvrat.id_sum_vozvrat ">
                <v-icon  color="success" >
                  mdi-microsoft-excel
                  </v-icon>
            </export-json-excel>

          </v-card-title>

          <div>
              <v-data-table
                dense
                :headers="headers_furush"
                :items="vozvrat_list"
                item-key="name"
                class="elevation-1"
                :search="search"
              >


                <template v-slot:body.prepend>
                  <tr>
                    <td>
                      <v-text-field v-model="kod" type="number" label="Код"></v-text-field>
                    </td>
                    <td>
                      <v-text-field v-model="nom" type="text" label="Наименование"></v-text-field>
                    </td>
                    <td></td>
                    <td></td>
                    <td>
                      <v-text-field v-model="summa" type="number" label="Сумма"></v-text-field>
                    </td>
                    <td></td>
                  </tr>
                </template>


                <template slot="body.append">
                  <tr>
                      <th class="title "></th>
                      <th class="title "></th>
                      <th class="title "></th>
                      <th class="title "></th>
                      <th class="title ">{{Number( sumFurush('summa')).toFixed(2) }}c</th>
                      <th class="title " style="color:red">{{Number( sumFurush('ub')).toFixed(2) }}c</th>
                  </tr>
              </template>
              </v-data-table>
            </div>

      </v-container> -->


      <v-snackbar
      v-model="snack"
      :timeout="3000"
      :color="snackColor"
     >
      {{ snackText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          v-bind="attrs"
          text
          @click="snack = false"
        >
          Закрыть
        </v-btn>
      </template>
     </v-snackbar>


    </v-card>



</template>

<script>
export default {

data: () => ({

  searching: "",
  search: "",
  s_smena: "",

  valutaho: [
    { valuta: "TJS", id_kurb: 1 },
    { valuta: "USD", id_kurb: 2 },
    { valuta: "RUB", id_kurb: 3 },
  ],

  date1: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      menu: false,
      date2: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      menu2: false,



filters: {
fio: "",
nom: "",
valuta: "",
firma: "",
comment: "",
},

kod: "",
nom: "",
shumora: "",
narkh: "",
summa: "",


headers: [
        {
          text: 'ID',
          align: 'start',
          value: 'id_pardokht',
        },
        { text: 'Поставщик', value: 'firma' },
        { text: 'Сумма вал.', value: 'mablag' },
        { text: 'Cумма смн', value: 'mablagi_kurs' },
        { text: 'Дата', value: 'sana' },
        { text: 'Пользователь', value: 'user' },
        { text: 'Комментарий', value: 'comment' },
        { text: 'id_kurb', value: 'id_kurb', align: ' d-none'  },
        { text: 'valuta', value: 'valuta', align: ' d-none'  },

],

    oplata_firma_fields:{

        "ID": "id_pardokht",
        "Поставщик": "firma",
        "Сумма вал.": 'mablag',
        "Сумма смн": 'mablagi_kurs',
        "Дата":"sana",
        "Пользователь":"user",
        "Комментарий":"comment",

        },

snack: false,
    snackColor: '',
    snackText: '',

loading: false,
vozvratho: [],
klents: [],
partners: [],
smeni: [],
vozvrat: {},
vozvrat_list: [],

furush_card: false,
sumfurush_card: true,
firmaho: [],

export_furush_fields: [

  {
      'title': 'Код',
      'name': 'kod',
      'width': '20',
      'type': 'Number',
      },
      {
      'title': 'Наименование',
      'name': 'nom',
      'width': '50'

      },

      {
      'title': 'Количество',
      'name': 'mikdor',
      'type': 'float',
      'width': '15'
      },
      {
      'title': 'Сумма',
      'name': 'summa',
      'type': 'float',
      'width': '20'
      },
      {
      'title': 'Сумма убытка',
      'name': 'ub',
      'type': 'float',
      'width': '20'
      },

],

export_sumfurush_fields: [

  {
      'title': '№',
      'name': 'id_sum_vozvrat',
      'width': '20',
      'type': 'Number',
      },
      {
      'title': 'Клиент',
      'name': 'fio',
      'width': '35'

      },

      {
      'title': 'Сумма',
      'name': 'sum_v',
      'type': 'float',
      'width': '15'
      },
      {
      'title': 'Скидка',
      'name': 'skidka',
      'type': 'float',
      'width': '20'
      },
      {
      'title': 'Наличий',
      'name': 'nakd',
      'type': 'float',
      'width': '20'
      },
      {
      'title': 'Из долг',
      'name': 'az_karz',
      'type': 'float',
      'width': '20'
      },
      {
      'title': 'Дата',
      'type': 'Date',
      'name': 'created_at',
      'width': '20'
      },

],


}),

mounted(){

  this.get_vozvratho();

  this.get_firmaho();
},

methods: {

    get_firmaho(){
          this.loading = true;
        axios.get('/api/get_firmaho',
                {
                    headers: {
                        "Content-type": "application/json"
                    }
                })
                .then(response => {
                        if(response.data.status){
                            this.loading = false;
                            this.firmaho = response.data.firmaho;
                        }else{
                            this.loading = false;
                            this.snack = true
                            this.snackColor = 'error'
                            this.snackText = "Ошибка получения фирмы"
                            setTimeout(() => {
                                this.snack = false;
                            }, 2000);
                        }
                    })
                    .catch(error => {
                        this.loading = false;
                        this.snack = true
                        this.snackColor = 'error'
                        this.snackText = error.response.data.message;
                            setTimeout(() => {
                                this.snack = false;
                            }, 2000);
                    });
  },
  sumField(key) {
  return  this.filteredProducts.reduce((a, b) => a + parseFloat((b[key] || 0)), 0)
  },

  sumFurush(key) {
  return  this.vozvrat_list.reduce((a, b) => a + parseFloat((b[key] || 0)), 0)
  },






  get_vozvratho(){
          this.vozvratho = [];
          this.$refs.menu.save(this.date1)
          this.$refs.menu2.save(this.date2)
          this.loading = true;


          axios.get('/api/get_pardokht/'+this.date1+'/'+this.date2,
                        {
                            headers: {
                                "Content-type": "application/json"
                            }
                        })
                        .then(response => {
                                if(response.data.status){
                                    this.vozvratho = response.data.pardokhtho
                                    this.loading = false;
                                setTimeout(() => {
                                        this.snack = false;
                                    }, 2000);
                                }else{
                                    this.loading = false;
                                    this.snack = true
                                    this.snackColor = 'error'
                                    this.snackText = "Не удалось получить данные"
                                    this.vozvratho = [];
                                    setTimeout(() => {
                                        this.snack = false;
                                    }, 2000);
                                }
                            })
                            .catch(error => {
                                this.vozvratho = [];
                                this.loading = false;
                                this.snack = true
                                this.snackColor = 'error'
                                this.snackText = error.response.data.message;
                                    setTimeout(() => {
                                        this.snack = false;
                                    }, 2000);
                            });
                  },

  search_mol(){
      this.vozvratho = [];
      this.loading = true;
      axios.post('/api/searching_mol_v', {
          search: this.searching
      })
      .then(response => {
          if(response.data.status){
              this.loading = false;
              this.searching = '';
               this.vozvratho = response.data.searching;
          }else{
              this.loading = false;
              this.snack = true
              this.snackColor = 'error'
              this.snackText = "Ошибка получения peremeshenies"
              setTimeout(() => {
                  this.snack = false;
              }, 2000);
          }
      })
      .catch(error => {
          this.loading = false;
          this.snack = true
          this.snackColor = 'error'
          //this.snackText = error.response.data.message;
              setTimeout(() => {
                  this.snack = false;
              }, 2000);
      });
      this.searching = '';

  },

  search_smena_v(){

      this.vozvratho = [];
      this.loading = true;
      axios.post('/api/search_smena_v', {
          search: this.s_smena
      })
      .then(response => {
          if(response.data.status){
              this.loading = false;
              this.s_smena = '';
               this.vozvratho = response.data.searching;

          }else{
              this.loading = false;
              this.snack = true
              this.snackColor = 'error'
              this.snackText = "Ошибка"
              setTimeout(() => {
                  this.snack = false;
              }, 2000);
          }
      })
      .catch(error => {
          this.loading = false;
        //  this.snack = true
         // this.snackColor = 'error'
          //this.snackText = error.response.data.message;

      });
      this.s_smena = '';

  },

  dblclick_sum_vozvat(event, {item}){
      this.vozvrat = item;
      this.sumfurush_card = false
      this.get_vozvrat_info(item.id_sum_vozvrat)

  },

  get_vozvrat_info(id){

      this.loading = true;
        axios.get('/api/get_vozvrat/' + id,
                {
                    headers: {
                        "Content-type": "application/json"
                    }
                })
                .then(response => {
                        if(response.data.status){
                            this.loading = false;
                            this.vozvrat_list = response.data.vozvrat_list;
                            this.furush_card = true;

                        }else{
                            this.loading = false;
                            this.snack = true
                            this.snackColor = 'error'
                            this.snackText = "Ошибка получения vozvrat"
                            setTimeout(() => {
                                this.snack = false;
                            }, 2000);
                        }
                    })
                    .catch(error => {
                        this.loading = false;
                        this.snack = true
                        this.snackColor = 'error'
                        this.snackText = error.response.data.message;
                            setTimeout(() => {
                                this.snack = false;
                            }, 2000);
                    });
  },

  back_to_sumfurush(){
      this.furush_card = false;
      this.sumfurush_card = true;
  },



},

computed: {

  filteredProducts() {
let filter = this.vozvratho.filter((id_sum_vozvrat) => {
  for (const [key, filterValue] of Object.entries(this.filters)) {
    // if (!filterValue.length) continue;
    if (!filterValue.length && typeof filterValue !== "boolean") continue; // No filters selected -> show all products.
    if (typeof filterValue === "boolean" && !filterValue) continue; // exclude the checkbox value if not true/false

    let dropdownValue = id_sum_vozvrat[key];

    //If its an array
    if (typeof filterValue === "object") {
      //Single value (single dropdown value)
      if (typeof dropdownValue === "string") {
        if (
          filterValue.findIndex((val) => {
            return val === dropdownValue.trim();
          }) === -1
        )
          return false;
        //Multiple values (multiple dropdown values)
      } else if (typeof dropdownValue === "object") {
        for (const filterString of filterValue) {
          if (dropdownValue.indexOf(filterString) === -1) return false;
        }
      }

      //If its a boolean
    } else if (typeof filterValue === "boolean") {
      if (typeof dropdownValue === "string") {
        if (dropdownValue.length == 0 && filterValue) return false;
        if (dropdownValue.length > 0 && !filterValue) return false;
      } else if (filterValue != dropdownValue) return false;

      //If its a string
    } else if (typeof filterValue === "string") {
      if (typeof filterValue === "string") {
        if (!dropdownValue || dropdownValue.indexOf(filterValue) === -1)
          return false;
      }
    }
  }
  return true;
});
return filter;

},

headers_furush() {
return [
  {
    text: "Код",
    value: "kod",
    align: "start",
    filter: value => {
      if (!this.kod) return true;
      return value == parseInt(this.kod);
    }
  },
  // {
  //   text: "кОД",
  //   align: "left",
  //   sortable: false,
  //   value: "kod",
  //   filter: f => { return ( f + '' ).toLowerCase().includes( this[ 'kod' ].toLowerCase() ) }
  // },
  {
    text: "Наименование",
    align: "left",
    sortable: false,
    value: "nom",
    filter: f => { return ( f + '' ).toLowerCase().includes( this[ 'nom' ].toLowerCase() ) }
  },
  // {
  //   text: "Количество",
  //   align: "left",
  //   sortable: false,
  //   value: "shumora",
  //   filter: f => { return ( f + '' ).toLowerCase().includes( this[ 'shumora' ].toLowerCase() ) }
  // },
  // {
  //   text: "Цена",
  //   align: "left",
  //   sortable: false,
  //   value: "narkhi_f",
  //   filter: f => { return ( f + '' ).toLowerCase().includes( this[ 'narkhi_f' ].toLowerCase() ) }
  // },
  // {
  //   text: "Сумма",
  //   align: "left",
  //   sortable: false,
  //   value: "summa",
  //   filter: f => { return ( f + '' ).toLowerCase().includes( this[ 'summa' ].toLowerCase() ) }
  // },

  {
    text: "Количество",
    value: "mikdor",
    filter: value => {
      if (!this.shumora) return true;
      return value == parseInt(this.shumora);
    }
  },
  {
    text: "Цена",
    value: "narkh_v",
    filter: value => {
      if (!this.narkh) return true;
      return value == parseInt(this.narkh);
    }
  },
  {
    text: "Сумма",
    value: "summa",
    filter: value => {
      if (!this.summa) return true;
      return value == parseInt(this.summa);
    }
  },
  {
    text: "Убыток",
    value: "ub",

  },

];
}

}

}
</script>

<style  scoped>

</style>



